import { Box, BoxProps } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useUser } from '../../../../../hooks/user';
import { listUserOnboardsService } from '../../../../../services/Users/ListUserOnboardsService';
import { IOnboardTableItem, OnboardTable } from './components/OnboardTable';

type IUserOnboardTableProps = BoxProps;

export const UserOnboardTable = (
  props: IUserOnboardTableProps,
): JSX.Element => {
  const { user } = useUser();

  const [onboardsList, setOnboardsList] = useState<IOnboardTableItem[]>([]);

  useEffect(() => {
    async function loadOnboards(userId: string): Promise<void> {
      const onboards = await listUserOnboardsService(userId);

      setOnboardsList(onboards);
    }

    if (user) {
      loadOnboards(user.id);
    }
  }, [user]);

  const handleUpdateOnboard = (updatedOnboard: IOnboardTableItem): void => {
    setOnboardsList((prevState) =>
      prevState.map((onboard) =>
        onboard.id === updatedOnboard.id ? updatedOnboard : onboard,
      ),
    );
  };

  return (
    <Box {...props}>
      <OnboardTable
        onboards={onboardsList}
        showOnboardUrl={user?.userAssignments[0]?.featureGroup.useOnboardUrl}
        onUpdateOnboard={handleUpdateOnboard}
      />
    </Box>
  );
};
